import { useContext } from 'react'
import DeleteContext from '../context/DeleteProvider';

const useDelete = () => {
    return useContext(DeleteContext);
}

export default useDelete